import {Action, configureStore, ThunkAction} from "@reduxjs/toolkit"

// Reducers
import authReducer from "./redusers/authSlice";
import themeReducer from "./redusers/themeSlice";
import commonReducer from "./redusers/commonSlice";
import storeReducer from "./redusers/storeSlice";
import enumStoreMapReducer from "./redusers/enumStoreMapSlice";
import localizationSlice from "./redusers/localizationSlice";
import localizationStoreSlice from "./redusers/localizationStoreSlice";
import sessionDataSlice from "./redusers/sessionDataSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        theme: themeReducer,
        localization:localizationSlice,
        localizationStore:localizationStoreSlice,
        sessionData:sessionDataSlice,
        common: commonReducer,
        store: storeReducer,

        enumStoreMap: enumStoreMapReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
